
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/usuario/[userUsername]",
      function () {
        return require("private-next-pages/usuario/[userUsername].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/usuario/[userUsername]"])
      });
    }
  